(function() {
  var __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  define('app/views/songs/song',['marionette', 'templates', 'moment'], function(Marionette, templates, moment) {
    'use strict';
    var SongView;
    return SongView = (function(_super) {
      __extends(SongView, _super);

      function SongView() {
        return SongView.__super__.constructor.apply(this, arguments);
      }

      SongView.prototype.tagName = 'li';

      SongView.prototype.className = 'song';

      SongView.prototype.template = templates.songs.song;

      SongView.prototype.modelEvents = {
        'change': 'render'
      };

      SongView.prototype.serializeData = function() {
        var data;
        data = SongView.__super__.serializeData.apply(this, arguments);
        if (data.source_type === 'Playlist') {
          data.from_playlist = true;
        }
        if (this.song.currentSong()) {
          data.current_song = true;
        }
        return data;
      };

      SongView.prototype.initialize = function(options) {
        this.song = this.model;
        SongView.__super__.initialize.apply(this, arguments);
        if (this.song.currentSong()) {
          return this.updateProgressTimer = setInterval((function(_this) {
            return function() {
              return _this.updateProgress();
            };
          })(this), 1000);
        }
      };

      SongView.prototype.updateProgress = function() {
        if (!this.song.currentSong()) {
          clearInterval(this.updateProgressTimer);
          this.trigger('finished');
          this.render();
        }
        return this.$('.progress-bar').css({
          width: this.song.progressPercent() + '%'
        });
      };

      SongView.prototype.onBeforeDestroy = function() {
        return clearInterval(this.updateProgressTimer);
      };

      return SongView;

    })(Marionette.ItemView);
  });

}).call(this);

//# sourceMappingURL=song.js.map
;
